import { PersonalContentRouting } from '@aipb/personal-content/shared/routing';
import { Routes } from '@angular/router';
import { MessagesPageComponent } from './pages/messages-page/messages-page.component';
import { JoinCollectionPageComponent } from './pages/join-collection-page/join-collection-page.component';

export const CoopRoutes: Routes = [
  {
    path: PersonalContentRouting.coopDefaultPath,
    component: MessagesPageComponent
  },
  {
    path: PersonalContentRouting.coopJoinPath,
    component: JoinCollectionPageComponent
  }
];
